// extracted by mini-css-extract-plugin
export var activeDot = "e_T_cs";
export var dotsWrapper = "e_T_cr";